/* global window */
import React, { useEffect, useRef } from 'react';
import { useCookies } from 'react-cookie';
import { Dropdown, useDropdown, Typography, Button } from '@vtblife/uikit';
import { RoleType } from '@vtblife/event-bus-events';

import classname from '@search/classname/src';

import { useM2AuthContext } from '@search/auth/src/M2AuthProvider';

const config = typeof window === 'undefined' ? {} : (window.CONFIG || {});

const MODERATOR_EXTENSION_PATH = `${config.moderHost || 'https://moder.m2.ru/'}moderator-extension/unified-offer/`;

import './styles.css';

interface IModerationExtensionParams {
    id: string;
}

const cn = classname.bind(null, 'ModerationExtension');
const COOKIE_M2_INNER = 'm2_inner';

const DropdownControl = () => {
    const { toggle, opened, registerControl } = useDropdown();
    const control = useRef(null);

    useEffect(() => {
        if (control.current) registerControl(control.current);
    }, [ registerControl ]);

    return (
        <Button
            ref={control}
            size='s'
            dataTest='offer-map-show'
            onClick={() => toggle()}
            variant={opened ? 'primary' : 'transparent'}
            icon='information-circle'
        />
    );
};

const CardVisibilityInfo = (
    <div className={cn('info')}>
        <Typography
            variant='secondary-alone'
            color='secondary'
        >
            Информация доступна пользователям из внутренней сети M2, а также в роли Employee
        </Typography>
    </div>
);

export const ModeratorExtension: React.FC<IModerationExtensionParams> = ({ id }: { id: string }) => {
    const { auth } = useM2AuthContext();
    const [ cookie ] = useCookies([ COOKIE_M2_INNER ]);

    return (auth.isAuthenticated && auth.user.currentRoleType === RoleType.Employee) || cookie[COOKIE_M2_INNER] ? (
        <div className={cn()}>
            <Dropdown>
                <DropdownControl />
                <Dropdown.Content placement='body' positioning='end'>
                    <div className={cn('content')}>
                        {CardVisibilityInfo}
                        <iframe
                            className={cn('frame')}
                            src={`${MODERATOR_EXTENSION_PATH}${id}`}
                            width='100%'
                            height='250px'
                        >
                        </iframe>
                    </div>
                </Dropdown.Content>
            </Dropdown>
        </div>
    ) : null;
};
